import { getAttrMarkup, register } from '@wm/transpiler';
import { IDGenerator } from '@wm/core';

const tagName = 'div';
const idGen = new IDGenerator('wm_custom');
register('wm-custom', () => {
  return {
    pre: attrs => {
      const counter = idGen.nextUid();
      return `<${tagName} wmCustom #${counter}="wmCustom" wmsTransclude ${getAttrMarkup(attrs)}><i class="wms wms-widget-html"></i>`;
    },
    post: () => `</${tagName}>`
  };
});
export default () => { };
